export const layout = {
  xxlg: '1800px',
  xlg: '1400px',
  subxlg: '1250px',
  lg: '1100px',
  subLg: '950px',
  md: '900px',
  subMd: '800px',
  sm: '700px',
  xs: '500px',
  xxs: '420px',
  subXxs: '320px',
};

export type LayoutBreakpoints = keyof typeof layout;
